import angular from 'angular';
import loansRepaymentModalComponent from './loansRepaymentModal.component';

let loansRepaymentModalModule = angular.module('loansRepaymentModal', [
])

.component('loansRepaymentModal', loansRepaymentModalComponent)

.name;

export default loansRepaymentModalModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentModal/loansRepaymentModal.js